import React from 'react';
import * as R from 'ramda';
import i18next from 'i18next';
import styled from 'styled-components';

import { PrimaryButtonS, TextInput } from '../../common';

const Form = styled.form`
  width: 92%;
  display: flex;
  flex-direction: column;
`;

const InputWrapper = styled.div`
  width: 360px;
  min-height: 70px;
`;


export const AdminProfileForm = ({
  values,
  errors,
  touched,
  onSubmit,
  onChange,
  onBlur,
  isSubmitting,
}) => (
  <Form {...{ onSubmit }}>
    <InputWrapper >
      <TextInput
        name="email"
        type="text"
        label={i18next.t('forms.common.emailForm.label')}
        fFamily="regular"
        fontWeight="normal"
        placeholder={i18next.t('forms.common.emailForm.placeholder')}
        {...{ onChange, onBlur }}
        value={R.prop('email', values)}
        isError={R.prop('email', errors) && R.prop('email', touched)}
        error={errors.email}
      />
    </InputWrapper >

    <InputWrapper >
      <TextInput
        name="name"
        type="text"
        label={i18next.t('forms.common.name.label')}
        fFamily="regular"
        fontWeight="normal"
        placeholder={i18next.t('forms.common.name.placeholder')}
        {...{ onChange, onBlur }}
        value={R.prop('name', values)}
        isError={R.prop('name', errors) && R.prop('name', touched)}
        error={errors.name}
      />
    </InputWrapper >

    <PrimaryButtonS
      disabled={isSubmitting}
      style={{ width: '215px' }}
      loading={isSubmitting}
      type="submit"
    >
      {i18next.t('adminPanel.profile.saveBtn')}
    </PrimaryButtonS>
  </Form>
);
